<template>
    <el-dialog
        :visible.sync="dialogVisible"
        width="420px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="true"
        custom-class="payment-dialog"
        center
        @close="handleClose"
    >
        <div slot="title" class="payment-dialog-title">
            <i class="el-icon-shopping-bag-2"></i>
            <span>{{ $t('confirmYourOrder') }}</span>
        </div>
        <div class="payment-dialog-content">
            <!-- 套餐信息卡片 -->
            <div class="plan-info-card">
                <div class="plan-name">{{ planName }}</div>
                <div class="plan-price-wrapper">
                    <span class="plan-currency">{{ planCurrency }}</span>
                    <span class="plan-amount">{{ planAmount }}</span>
                </div>
            </div>

            <!-- 二维码区域 -->
            <div class="qr-code-container">
                <div class="qr-code-header">
                    <i class="el-icon-qr-code"></i>
                    <span>{{ $t('scanToPayTip') }}</span>
                </div>
                <div class="qr-code-wrapper">
                    <img
                        v-if="currentQrCode"
                        :src="currentQrCode"
                        class="qr-code-image"
                        alt="QR Code"
                    />
                    <div v-else class="qr-code-loading">
                        <i class="el-icon-loading"></i>
                        <span>{{ $t('paymentConfirming') }}</span>
                    </div>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button
                @click="handleCompleted"
                class="payment-done-btn"
            >
                <i class="el-icon-check"></i>
                {{ $t('paymentCompleted') }}
            </el-button>
        </span>
    </el-dialog>
</template>

<script>
import router from '@/router'

export default {
    name: 'QrCodePaymentDialog',
    props: {
        // 是否显示弹窗
        visible: {
            type: Boolean,
            default: false
        },
        // 套餐名称
        planName: {
            type: String,
            default: ''
        },
        // 套餐金额
        planAmount: {
            type: String,
            default: ''
        },
        // 币种
        planCurrency: {
            type: String,
            default: ''
        },
        // 二维码图片（base64）
        qrCodeImage: {
            type: String,
            default: ''
        },
        // 订单号
        orderSn: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            dialogVisible: false,
            currentQrCode: ''
        }
    },
    watch: {
        visible(val) {
            this.dialogVisible = val
            if (val) {
                this.currentQrCode = this.qrCodeImage
            }
        },
        dialogVisible(val) {
            this.$emit('update:visible', val)
        },
        qrCodeImage(val) {
            if (this.dialogVisible) {
                this.currentQrCode = val
            }
        }
    },
    methods: {
        // 关闭弹窗
        handleClose() {
            this.currentQrCode = ''
            this.$emit('close')
        },
        // 支付完成
        handleCompleted() {
            this.currentQrCode = ''
            this.$emit('completed')
            // 跳转到 account 页面
            router.push('/account')
        }
    }
}
</script>

<style scoped>
/* 支付弹窗样式 */
::v-deep .payment-dialog {
    border-radius: 12px;
    overflow: hidden;
}

::v-deep .payment-dialog .el-dialog__header {
    padding: 16px 20px;
}

::v-deep .payment-dialog .el-dialog__body {
    padding: 0 20px 20px;
}

::v-deep .payment-dialog .el-dialog__footer {
    padding: 0 20px 20px;
}

.payment-dialog-title {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    font-size: 16px;
    font-weight: 600;
    color: #333;
}

.payment-dialog-title i {
    font-size: 18px;
    color: #ee3769;
}

.payment-dialog-content {
    padding: 0;
}

/* 套餐信息卡片 */
.plan-info-card {
    background: linear-gradient(135deg, #ee3769 0%, #ff6b9d 100%);
    border-radius: 10px;
    padding: 16px;
    margin-bottom: 16px;
    text-align: center;
    box-shadow: 0 4px 12px rgba(238, 55, 105, 0.25);
}

.plan-name {
    font-size: 14px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.9);
    margin-bottom: 8px;
}

.plan-price-wrapper {
    display: flex;
    align-items: baseline;
    justify-content: center;
    gap: 4px;
}

.plan-currency {
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    text-transform: uppercase;
}

.plan-amount {
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 1;
}

/* 二维码区域 */
.qr-code-container {
    background: #fafafa;
    border-radius: 10px;
    padding: 16px;
    text-align: center;
}

.qr-code-header {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    margin-bottom: 12px;
    font-size: 14px;
    font-weight: 500;
    color: #333;
}

.qr-code-header i {
    font-size: 16px;
    color: #ee3769;
}

.qr-code-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 160px;
    background: #ffffff;
    border-radius: 8px;
    padding: 12px;
    border: 1px solid #eee;
}

.qr-code-image {
    width: 150px;
    height: 150px;
    object-fit: contain;
}

.qr-code-loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    color: #999;
    font-size: 13px;
}

.qr-code-loading i {
    font-size: 24px;
    color: #ee3769;
    animation: rotating 1.5s ease-in-out infinite;
}

@keyframes rotating {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}

/* 底部按钮 */
.dialog-footer {
    display: block;
    text-align: center;
}

.payment-done-btn {
    width: 100%;
    height: 40px;
    font-size: 14px;
    font-weight: 600;
    color: #ffffff !important;
    background: linear-gradient(135deg, #ee3769 0%, #ff6b9d 100%) !important;
    border: none !important;
    border-radius: 8px !important;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
}

.payment-done-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(238, 55, 105, 0.35);
}

.payment-done-btn i {
    font-size: 16px;
}

/* 移动端适配 */
@media (max-width: 768px) {
    ::v-deep .payment-dialog {
        width: 85% !important;
        margin: 0 auto;
    }

    ::v-deep .payment-dialog .el-dialog__header {
        padding: 12px 16px;
    }

    ::v-deep .payment-dialog .el-dialog__body {
        padding: 0 16px 16px;
    }

    ::v-deep .payment-dialog .el-dialog__footer {
        padding: 0 16px 16px;
    }

    .plan-info-card {
        padding: 12px;
        margin-bottom: 12px;
    }

    .plan-name {
        font-size: 13px;
        margin-bottom: 6px;
    }

    .plan-amount {
        font-size: 28px;
    }

    .plan-currency {
        font-size: 14px;
    }

    .qr-code-container {
        padding: 12px;
    }

    .qr-code-header {
        font-size: 13px;
        margin-bottom: 10px;
    }

    .qr-code-wrapper {
        min-height: 140px;
        padding: 10px;
    }

    .qr-code-image {
        width: 130px;
        height: 130px;
    }

    .payment-done-btn {
        height: 38px;
        font-size: 13px;
    }
}
</style>
